module.exports = __webpack_public_path__ + "img/planner-active.4f6ce90d.svg";